import { TableColumnType } from "antd";

import { RightAlignedCell } from "../MidstreamNavigatorTable.styles";
import type { WellContribution } from "../types";

// Column definitions for Facility mode (Well Contributions)
export function getFacilityColumns(): TableColumnType<WellContribution>[] {
  return [
    {
      title: "UWID",
      dataIndex: "uwi",
      key: "uwi",
      width: "20%"
    },
    {
      title: "Resource Play",
      dataIndex: "resourcePlay",
      key: "resourcePlay",
      width: "15%"
    },
    {
      title: "Operator",
      dataIndex: "operator",
      key: "operator",
      width: "15%"
    },
    {
      title: "Gas Rate (Mcf/d)",
      dataIndex: "gasRate",
      key: "gasRate",
      width: "10%",
      render: (value: string) => <RightAlignedCell>{value}</RightAlignedCell>
    },
    {
      title: "Monthly Gas (MMcf)",
      dataIndex: "monthlyGasVolume",
      key: "monthlyGasVolume",
      width: "13%",
      render: (value: string) => <RightAlignedCell>{value}</RightAlignedCell>
    },
    {
      title: "Contribution % (Current Month)",
      dataIndex: "value",
      key: "value",
      width: "17%",
      render: (value: string) => <RightAlignedCell>{value}</RightAlignedCell>
    },
    {
      title: "Depth",
      dataIndex: "distance",
      key: "distance",
      width: "10%",
      render: (value: number) => <RightAlignedCell>{value}</RightAlignedCell>
    }
  ];
}
